document.addEventListener('DOMContentLoaded', () => {
  const initSplide = (root = document) => {
    const splides = root.querySelectorAll('.splides-products');
    if (!splides.length) return;

    const options = {
      fixedWidth: '156px',
      perPage: 1,
      gap: 18,
      pagination: false,
      arrowPath: 'M17.2417 10.5664L16.4561 11.3521L25.0986 19.9946L16.456 28.6372L17.2417 29.4229L26.6698 19.9948L26.6697 19.9946L26.6698 19.9945L17.2417 10.5664Z',
      mediaQuery: 'min',
      arrows: false,
      breakpoints: {
        715: {fixedWidth: 'calc((100vw - (18px * 5)) / 4)', perPage: 4},
        768: {fixedWidth: 'calc((100vw - (36px * 5)) / 4)', gap: 36},
        1272: {fixedWidth: '273px'},
      },
    };

    splides.forEach((el) => {
      if (el.dataset.splideMounted === '1') return; // 二重mount防止
      new Splide(el, options).mount();
      el.dataset.splideMounted = '1';
    });
  };

  const pr = document.querySelector('product-recommendations');
  if (!pr) {
    initSplide(document);
    return;
  }

  // すでに入ってた場合
  initSplide(pr);

  // 後から入ってくる場合を監視
  const obs = new MutationObserver(() => initSplide(pr));
  obs.observe(pr, {childList: true, subtree: true});
});
